import { ActionIcon, Drawer, Flex, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import cn from 'classnames';
import * as React from 'react';

import s from './MobileBottomDrawer.module.scss';

type MobileBottomDrawerProps = React.PropsWithChildren<{
  opened: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  headerLeftAddon?: React.ReactNode;
  headerAddon?: React.ReactNode;
  actions?: React.ReactNode;
  size?: string | number;
  className?: string;
  contentClassName?: string;
  footerClassName?: string;
  zIndex?: number;
}>;

const MobileBottomDrawer: React.FC<MobileBottomDrawerProps> = ({
  opened,
  onClose,
  title,
  subtitle,
  headerLeftAddon,
  headerAddon,
  actions,
  size,
  className,
  contentClassName,
  footerClassName,
  zIndex,
  children,
}) => {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="bottom"
      size={size}
      zIndex={zIndex}
      withCloseButton={false}
      classNames={{
        root: cn(s.root, className),
        content: cn(s['root__drawer-content'], contentClassName),
        body: s.root__body,
      }}
      overlayProps={{ opacity: 0.35, blur: 2 }}
    >
      <div className={cn(s.root__content, contentClassName)}>
        <Flex className={s.root__header} justify="space-between" align="center" gap="sm">
          <Flex className={s.root__left} align="center" gap="xs">
            {headerLeftAddon}
            <div className={s['root__header-info']}>
              {subtitle && (
                <Text className={s.root__subtitle} size="xs" fw={600} tt="uppercase" c="dimmed">
                  {subtitle}
                </Text>
              )}
              <Text className={s.root__title} size="lg" fw={700}>
                {title}
              </Text>
            </div>
          </Flex>
          <Flex align="center" gap="xs" className={s.root__actions}>
            {headerAddon}
            <ActionIcon
              variant="light"
              c="gray"
              color="gray"
              size="md"
              radius="999"
              aria-label="Закрыть"
              onClick={onClose}
            >
              <IconX color="gray" size={18} />
            </ActionIcon>
          </Flex>
        </Flex>
        <div className={s['root__body-content']}>{children}</div>
        {actions && <div className={cn(s.root__footer, footerClassName)}>{actions}</div>}
      </div>
    </Drawer>
  );
};

export default React.memo(MobileBottomDrawer);
